import { useEffect, useState } from "react";

import Grid from "@mui/material/Grid";
import MuiMenuItem from "@mui/material/MenuItem";
import MuiSelect from "@mui/material/Select";

import Button from "@mui/material/Button";
import { Container, InputLabel } from "@mui/material";
import Alert from "@mui/material/Alert";
import FormControlLabel from "@mui/material/FormControlLabel";

import clone from "lodash-es/clone";

import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import ProgressBar from "../../components/ProgressBar";
import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Checkbox from "@mui/material/Checkbox";

import { doService } from "../../services/ServiceHelper";
import { getUserSettings, saveUserSettings } from "../../services/UserService";

import {
  getBathroomPassTypes,
  getPassLocations,
} from "../../services/PassService";

const TeacherSettings = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [_showProgress, setShowProgress] = useState(false);
  const [_settings, setSettings] = useState({});
  const [_searchPerformed, setSearchPerformed] = useState(false);

  const [_passTypes, setPassTypes] = useState([]);
  const [_passLocations, setPassLocations] = useState([]);

  useEffect(() => {
    initPassTypes();
    initSettings();
  }, []);

  const initSettings = () => {
    setShowProgress(true);
    //startDate, endDate, studentEid, studentListEid, activityEid, period, orderBy
    doService(getUserSettings(_school, _jwt), (results) => {
      if (results.data.defaultBathroomLocationId == null) {
        results.data.defaultBathroomLocationId = "XX";
      }
      if (results.data.defaultBathroomPassTypeId == null) {
        results.data.defaultBathroomPassTypeId = "XX";
      }
      setSettings(results.data);
      setShowProgress(false);
      setSearchPerformed(true);
    });
  };

  const initPassTypes = () => {
    doService(getBathroomPassTypes(_school, _jwt), (result) => {
      setPassTypes(result.data);
    });
    doService(getPassLocations(_school, _jwt), (result) => {
      setPassLocations(result.data);
    });
  };

  const handleSave = () => {
    setShowProgress(true);
    doService(saveUserSettings(_school, _jwt, _settings), (results) => {
      // console.log(results.data);
      setShowProgress(false);
    });
  };

  const handleChangeHallPassEmails = (event) => {
    const settings = clone(_settings);
    settings.receiveHallPassEmails = event.target.checked ? "Y" : "N";
    setSettings(settings);
  };

  const handleChangePassType = (event) => {
    const settings = clone(_settings);
    settings.defaultBathroomPassTypeId = event.target.value;
    setSettings(settings);
  };

  const handleChangePassLocation = (event) => {
    const settings = clone(_settings);
    settings.defaultBathroomLocationId = event.target.value;
    setSettings(settings);
  };

  const handleChangeMarkStudentCanModify = (event) => {
    const settings = clone(_settings);
    settings.markStudentCanModify = event.target.checked ? "Y" : "N";
    setSettings(settings);
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Teacher Settings" showBack={true} />
        <ProgressBar showProgress={_showProgress} />

        <Alert severity="info" sx={{ pb: 0, mt: 1 }}>
          Please click the Save button below to apply changes.
        </Alert>

        {_searchPerformed === true && (
          <>
            <br />
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }} expanded>
                  <AccordionSummary className="accordionTitle">
                    Activity Settings
                  </AccordionSummary>
                  <AccordionDetails>
                    <FormControlLabel
                      sx={{ mt: 0 }}
                      control={
                        <Checkbox
                          onChange={(event) =>
                            handleChangeMarkStudentCanModify(event)
                          }
                          checked={_settings.markStudentCanModify === "Y"}
                        />
                      }
                      label={
                        "Mark Students Can Modify"
                      }
                    />


                  </AccordionDetails>
                </Accordion>
              </Grid>
              <Grid item xs={6}>
                <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }} expanded>
                  <AccordionSummary className="accordionTitle">
                    Pass Settings
                  </AccordionSummary>
                  <AccordionDetails>
                    <InputLabel>Default Bathroom Hall Pass Type</InputLabel>
                    <MuiSelect
                      fullWidth
                      size="small"
                      value={_settings.defaultBathroomPassTypeId}
                      onChange={(evt) => handleChangePassType(evt)}
                    >
                      <MuiMenuItem key="XX" value="XX">
                        -- SELECT PASS TYPE --
                      </MuiMenuItem>
                      {_passTypes.map((passType) => (
                        <MuiMenuItem key={passType.id} value={passType.id}>
                          {passType.name}
                        </MuiMenuItem>
                      ))}
                    </MuiSelect>
                    <InputLabel sx={{ mt: 2 }}>
                      Default Location for Passes
                    </InputLabel>
                    <MuiSelect
                      fullWidth
                      size="small"
                      value={_settings.defaultBathroomLocationId}
                      onChange={(evt) => handleChangePassLocation(evt)}
                    >
                      <MuiMenuItem key="XX" value="XX">
                        -- SELECT LOCATION --
                      </MuiMenuItem>
                      {_passLocations.map((loc) => (
                        <MuiMenuItem key={loc.id} value={loc.id}>
                          {loc.name}
                        </MuiMenuItem>
                      ))}
                    </MuiSelect>

                    <FormControlLabel
                      sx={{ mt: 2 }}
                      control={
                        <Checkbox
                          onChange={(event) =>
                            handleChangeHallPassEmails(event)
                          }
                          checked={_settings.receiveHallPassEmails === "Y"}
                        />
                      }
                      label={"Receive Hall Pass Emails"}
                    />

                    <br />
                  </AccordionDetails>
                </Accordion>
              </Grid>
            </Grid>

            <Button sx={{ mt: 2 }} variant="contained" onClick={handleSave}>
              Save Teacher Settings
            </Button>
          </>
        )}
      </Container>
    </>
  );
};

export default TeacherSettings;
